module.exports = require('./lodash');


//////////////////
// WEBPACK FOOTER
// ./~/lodash/index.js
// module id = 991
// module chunks = 1